import { render, staticRenderFns } from "./EditImages.vue?vue&type=template&id=80801dc8"
import script from "./EditImages.vue?vue&type=script&lang=js"
export * from "./EditImages.vue?vue&type=script&lang=js"
import style0 from "./EditImages.vue?vue&type=style&index=0&id=80801dc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports